/** @module Specification/SpecificationDataSheet/NewSpecialSpecificationSectionItemController.js */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/ActionView",
	"csi/def",
	"csi/def/Field",
	"csi/def/ViewFactory",
	"csi/reflection",
	"csi/table/New",
	"csi/xml"
], function(declare,lang,ActionView,def,Field,ViewFactory,reflection,New,xml) {

	var DEFINITION_FORM = "Definition";
	var DEFINITION_FORM_ID = "SpecificationItemDefinition";
	var DESCRIPTION = "Description";
	var VIEW_TYPE = "SpecificationSectionItem";

	return declare(New, {
		/**
		 * Combine the SDI form
		 * Handle the Description attribute from two forms(SDI&SSI)
		 * @param {csi.view.Widget} view
		 */
		onCreatePopup: function(view) {
			// add the description attribute of the SSI form by default if not exist
			if (!view.getField(DESCRIPTION)) {
				var f = lang.mixin(new Field(), {
					m_id: DESCRIPTION
				});

				view.insertField(f, 0);
			}

			view.combineForm(true, DEFINITION_FORM);
			var definition = this.m_cache.getNode(this.getParent().Definition);
			view.addFixedValue(view.getCombinedFieldName(DEFINITION_FORM_ID, reflection.ATTR_SUBTYPE), definition.Subtype);

			// check if description attribute of the SDI form exist, if it does, remove it
			view.defView.removeField(view.getCombinedFieldName(DEFINITION_FORM_ID, DESCRIPTION));

			this.inherited(arguments);
		},

		/**
		 * Create form view if needed
		 * @param {csi.def.ViewRef} vr
		 */
		getActionView: function(vr) {
			var av = this.inherited(arguments);

			if (!av) {
				var defView = ViewFactory.create(null, 'Form', VIEW_TYPE);
				av = new ActionView(this, defView);
			}

			return av;
		}
	});
});